//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    name: 'ProfileNewsPopup',

    mixins: [ProfileData],

    props: {
        company: {
        },
        news: {
        },
    },

    data() {
        return {
        }
    },

    methods: {

    },

    computed: {

        addthis() {
            return this.$store.state.ccm.addthis
        },

    },


}

